// What Radix's dialogs did through react-remove-scroll-bar, kept to the letter
// because page chrome reads it: the toolbar steps below an open dialog on
// [data-scroll-locked] and recenters by --removed-body-scroll-bar-size.
const LOCK_ATTRIBUTE = 'data-scroll-locked';

const lock: { style: HTMLStyleElement | null } = { style: null };

/**
 * Stops the page from scrolling behind a modal dialog and hands the width of
 * the scrollbar it hides to the body's right margin, so the page does not
 * shift. Locks nest: the page scrolls again once every lock is released.
 */
export function lockPageScroll(): () => void {
   const { body } = document;
   const count = lockCount();
   // Measured once, by the first lock: under it the scrollbar is already gone.
   if (count === 0) lock.style = insertLockStyle();
   body.setAttribute(LOCK_ATTRIBUTE, String(count + 1));

   let isReleased = false;
   return () => {
      if (isReleased) return;
      isReleased = true;
      const remaining = lockCount() - 1;
      if (remaining > 0) {
         body.setAttribute(LOCK_ATTRIBUTE, String(remaining));
         return;
      }
      body.removeAttribute(LOCK_ATTRIBUTE);
      lock.style?.remove();
      lock.style = null;
   };
}

function lockCount() {
   const count = Number.parseInt(document.body.getAttribute(LOCK_ATTRIBUTE) ?? '0', 10);
   return Number.isFinite(count) ? count : 0;
}

function insertLockStyle() {
   const body = getComputedStyle(document.body);
   const left = Number.parseInt(body.marginLeft, 10) || 0;
   const top = Number.parseInt(body.marginTop, 10) || 0;
   const right = Number.parseInt(body.marginRight, 10) || 0;
   const gap = Math.max(0, window.innerWidth - document.documentElement.clientWidth + right - left);

   const style = document.createElement('style');
   style.textContent = `
body[${LOCK_ATTRIBUTE}] {
   overflow: hidden !important;
   overscroll-behavior: contain;
   position: relative !important;
   padding-left: ${left}px;
   padding-top: ${top}px;
   padding-right: ${right}px;
   margin-left: 0;
   margin-top: 0;
   margin-right: ${gap}px !important;
   --removed-body-scroll-bar-size: ${gap}px;
}`;
   document.head.append(style);
   return style;
}
